import Paginate from '../pagination/paginate'
import { useNavigate, useParams } from 'react-router-dom'
import { appGetAllUser, appUploadUser } from '../../store/user'
import { useDispatch, useSelector } from 'react-redux'
import * as XLSX from 'xlsx'
import swal from 'sweetalert'
import PostPreview from '../PostPreview/PostPreview'
import ExportButton from '../../common/ExportButton'
import { sansthaUserExportColumns } from '../../config/exportColumns/sansthaUserExportColumns'
import { useEffect, useState } from 'react'

function Users({ hubDetails, sansthaDetails, users, userpage, setUserPage }) {
	const params = useParams()
	const { id } = useParams()
	const dispatch = useDispatch()
	const navigate = useNavigate()
	const userspaginate = useSelector(state => state.usersReducer.paginate)
	const [searchType, setSearchType] = useState('firstName')
	const [search, setSearch] = useState('')
	const [activeFilters, setActiveFilters] = useState({})
	const userLabel = sansthaDetails && sansthaDetails._id ? 'Member' : 'User'

	const sansthaId = localStorage.getItem('sansthaId')
	const permissionOfSanstha = localStorage.getItem('permissionOfSanstha')

	const hubId = localStorage.getItem('hubId')
	const permissionOfHub = localStorage.getItem('permissionOfHub')

	const finalSansthaId = sansthaId || permissionOfSanstha

	const [isUploading, setIsUploading] = useState(false)

	useEffect(() => {
		const params = {
			page: userpage,
			limit: 10,
			...activeFilters,
		}

		if (sansthaDetails?._id) {
			params.sansthaId = sansthaDetails._id
		} else if (hubDetails?._id) {
			params.hub = hubDetails._id
		}

		dispatch(appGetAllUser(params))
	}, [userpage, activeFilters, sansthaDetails?._id, hubDetails?._id])

	const handleDownloadExcel = () => {
		const sampleData = [
			{
				firstName: 'John',
				lastName: 'Doe',
				mobile: '9876543210',
			},
			{
				firstName: 'Jane',
				lastName: 'Smith',
				mobile: '9876500000',
			},
		]

		const wb = XLSX.utils.book_new()

		const wsData = XLSX.utils.json_to_sheet(sampleData, { origin: 'A1' })

		wsData['!cols'] = [{ wch: 20 }, { wch: 20 }, { wch: 15 }]

		XLSX.utils.book_append_sheet(wb, wsData, 'Members')

		const filename = 'sanstha_members_template.xlsx'

		XLSX.writeFile(wb, filename)
	}

	const handleExcelImport = event => {
		const file = event.target.files[0]
		if (!file) return

		setIsUploading(true)

		if (sansthaDetails && sansthaDetails._id) {
			dispatch(
				appUploadUser({
					hub: sansthaDetails.hub._id,
					sansthaId: sansthaDetails._id,
					file,
				}),
			)
				.then(() => {
					swal('Success', 'Members uploaded successfully!', 'success')

					dispatch(
						appGetAllUser({
							page: 1,
							limit: 10,
							sansthaId: sansthaDetails._id,
						}),
					)
				})
				.catch(error => {
					swal(
						'Upload Failed',
						error?.response?.data?.message || 'Failed to upload members',
						'error',
					)
				})
				.finally(() => {
					setIsUploading(false)
				})
		}

		event.target.value = ''
	}

	const getStatusBadgeClass = status => {
		switch (status) {
			case 'Active':
				return 'badge-success'
			case 'Inactive':
				return 'badge-danger'
			case 'Expired':
				return 'badge-warning'
			default:
				return 'badge-secondary'
		}
	}

	const handleSearch = () => {
		const filters = {}

		if (search) {
			filters[searchType] = search.trim()
		}

		setActiveFilters(filters)
		setUserPage(1)
	}
	const handleReset = () => {
		setSearch('')
		setSearchType('firstName')
		setActiveFilters({})
		setUserPage(1)
	}

	return (
		<div>
			<div className="mb-3 mr-2 d-flex justify-content-between align-items-center">
				<h4 className="ml-2 text-black">
					Total {userLabel}s: {hubDetails?.users?.length || sansthaDetails?.users?.length || 0}
				</h4>

				<div className="d-flex align-items-center mb-3 gap-2">
					<select
						className="form-control"
						value={searchType}
						onChange={e => setSearchType(e.target.value)}
						style={{ width: '180px' }}
					>
						<option value="firstName">First Name</option>
						<option value="lastName">Last Name</option>
						<option value="mobile">Mobile</option>
						<option value="email">Email</option>
					</select>

					<input
						type="text"
						className="form-control ml-1"
						placeholder={`Search by ${searchType}`}
						value={search}
						onChange={e => setSearch(e.target.value)}
						style={{ width: '220px' }}
					/>

					<button className="btn btn-info mx-2" onClick={handleSearch}>
						Search
					</button>

					<button className="btn btn-secondary" onClick={handleReset}>
						Reset
					</button>
				</div>
				<div className="dt-buttons btn-group">
					<ExportButton
						fetchAction={params =>
							dispatch(
								appGetAllUser({
									...params,
									page: 1,
									limit: 100000,
									sansthaId: sansthaId || permissionOfSanstha,
									loading: false,
								}),
							)
						}
						columns={sansthaUserExportColumns}
						fileName={sansthaDetails ? 'Sanstha_Members' : 'Hub_Users'}
						sheetName={sansthaDetails ? 'Members' : 'Users'}
						buttonText={`Export ${userLabel}`}
						className="btn btn-info mr-2"
					/>

					<button
						className="btn btn-default buttons-excel buttons-html5 btn-info mx-2"
						onClick={handleDownloadExcel}
						style={{ minWidth: '150px', height: '38px' }}
					>
						<span>Download {userLabel} Template</span>
					</button>

					<label
						className={`btn btn-info d-flex align-items-center gap-2 ${
							isUploading ? 'disabled' : ''
						}`}
						style={{
							minWidth: '170px',
							height: '38px',
							cursor: isUploading ? 'not-allowed' : 'pointer',
						}}
					>
						{isUploading && (
							<span
								className="spinner-border spinner-border-sm"
								role="status"
								aria-hidden="true"
							></span>
						)}
						{isUploading ? `Uploading ${userLabel}...` : `Upload ${userLabel}`}

						<input
							type="file"
							accept=".xlsx, .xls"
							style={{ display: 'none' }}
							onChange={handleExcelImport}
							disabled={isUploading}
						/>
					</label>
				</div>
			</div>
			<div className="table-responsive">
				<table className="table table-bordered table-hover">
					<thead className="">
						<tr>
							<th>Sr. No.</th>
							<th>{userLabel}</th>

							<th>Mobile</th>
							<th>Native Address</th>
							<th>Present Address</th>
							{sansthaDetails?._id && (
								<>
									<th>Membership Start Date</th>
									<th>Membership End Date</th>
									<th>Membership Type</th>
								</>
							)}
							<th>Joined Date</th>
							<th>Premium Member</th>
							<th>Membership Status</th>
							<th>Actions</th>
						</tr>
					</thead>
					<tbody>
						{users?.length > 0 ? (
							users.map((user, index) => {
								const matchedMembership = user?.joinedSanstha?.find(
									item => item?.sanstha?._id === sansthaDetails?._id,
								)
								return (
									<tr
										key={index}
										onClick={e => {
											if (
												e.target.closest('td:last-child') ||
												e.target.closest('button') ||
												e.target.closest('.btn')
											) {
												return
											}
											navigate(`/user/details/${user?._id}`)
										}}
										style={{
											cursor: 'pointer',
											backgroundColor: user?.isUserBlocked ? '#ffe5e5' : '',
										}}
									>
										<td>{index + 1 + (userpage - 1) * 10}</td>
										<td>
											<PostPreview value={user?.profilePic || '/img/user.jpg'} />
											{user?.firstName} {user?.lastName}
										</td>

										<td>{user?.mobile}</td>
										<td>
											{user?.nativePlaceAddress && user?.nativeArea && (
												<>
													{user?.nativePlaceAddress}, {user?.nativeArea}
												</>
											)}

											<br />
											{user?.nativeBlock &&
												user?.nativeDistrict &&
												user?.nativeState &&
												user?.nativePlacePincode && (
													<>
														<span>
															{' '}
															{user?.nativeBlock}, {user?.nativeDistrict} ,{user?.nativeState}{' '}
															{user?.nativePlacePincode}
														</span>
													</>
												)}
											<br />
										</td>
										<td>
											{user?.presentAddress && user?.presentnativeArea && (
												<>
													{user?.presentAddress}, {user?.presentnativeArea}
												</>
											)}
											<br />
											{user?.presentBlock &&
												user?.presentDistrict &&
												user?.presentState &&
												user?.presentPincode && (
													<>
														<span>
															{user?.presentBlock}, {user?.presentDistrict} ,{user?.presentState}{' '}
															{user?.presentPincode}
														</span>
													</>
												)}
										</td>

										{sansthaDetails?._id && (
											<>
												<td>
													{matchedMembership?.membershipStartDate
														? new Date(matchedMembership.membershipStartDate).toLocaleDateString(
																'en-US',
																{
																	year: 'numeric',
																	month: 'short',
																	day: 'numeric',
																},
														  )
														: '-'}
												</td>

												<td>
													{matchedMembership?.membershipEndDate
														? new Date(matchedMembership.membershipEndDate).toLocaleDateString(
																'en-US',
																{
																	year: 'numeric',
																	month: 'short',
																	day: 'numeric',
																},
														  )
														: '-'}
												</td>

												<td>{matchedMembership?.membershipType || '-'}</td>
											</>
										)}
										<td>
											{new Date(user?.joinedHubDate).toLocaleDateString('en-US', {
												year: 'numeric',
												month: 'short',
												day: 'numeric',
											})}
										</td>
										<td>
											{user?.premium === true ? (
												<span className="badge badge-primary">Premium Membership</span>
											) : (
												'-'
											)}
										</td>

										<td>
											{matchedMembership?.status ? (
												<span className={`badge ${getStatusBadgeClass(matchedMembership.status)}`}>
													{matchedMembership.status} Membership
												</span>
											) : (
												'-'
											)}
										</td>
										<td>
											<button
												onClick={e => {
													e.preventDefault()
													e.stopPropagation()
													navigate(`/user/details/${user?._id}`)
												}}
												className="btn btn-sm btn-primary mr-2"
												title="Details"
											>
												<em className="fa fa-eye fa-fw"></em>
											</button>
										</td>
									</tr>
								)
							})
						) : (
							<tr>
								<td colSpan="6" className="text-center">
									No {userLabel}s data available
								</td>
							</tr>
						)}
					</tbody>
				</table>
			</div>
			{userspaginate && <Paginate paginate={userspaginate} page={userpage} setPage={setUserPage} />}
		</div>
	)
}
export default Users
